module.exports = __webpack_public_path__ + "media/images/icon_file_download-4b5c054e76b0df3cbbc851854cd10c3c.svg";